import React from 'react';
import classNames from 'classnames';

interface SpinnerProps {
  /** Extra utility classes merged onto the wrapper (e.g. boot-site top padding). */
  className?: string;
}

/**
 * A component that renders a spinner (using css animations).
 *
 * The literal `preloader` class is kept on the wrapper because the export-modal
 * rules in styles/modal.css (`.export-*-modal .preloader`) still target it.
 */
export default function Spinner({ className }: SpinnerProps) {
  return (
    <div
      className={classNames(
        'preloader flex h-full w-full items-center justify-center',
        className
      )}
    >
      <div className="h-10 w-10">
        <div className="float-left h-1/3 w-1/3 bg-primary animate-[sk-cubeGridScaleDelay_1.3s_infinite_ease-in-out] [animation-delay:0.2s]" />
        <div className="float-left h-1/3 w-1/3 bg-primary animate-[sk-cubeGridScaleDelay_1.3s_infinite_ease-in-out] [animation-delay:0.3s]" />
        <div className="float-left h-1/3 w-1/3 bg-primary animate-[sk-cubeGridScaleDelay_1.3s_infinite_ease-in-out] [animation-delay:0.4s]" />
        <div className="float-left h-1/3 w-1/3 bg-primary animate-[sk-cubeGridScaleDelay_1.3s_infinite_ease-in-out] [animation-delay:0.1s]" />
        <div className="float-left h-1/3 w-1/3 bg-primary animate-[sk-cubeGridScaleDelay_1.3s_infinite_ease-in-out] [animation-delay:0.2s]" />
        <div className="float-left h-1/3 w-1/3 bg-primary animate-[sk-cubeGridScaleDelay_1.3s_infinite_ease-in-out] [animation-delay:0.3s]" />
        <div className="float-left h-1/3 w-1/3 bg-primary animate-[sk-cubeGridScaleDelay_1.3s_infinite_ease-in-out] [animation-delay:0s]" />
        <div className="float-left h-1/3 w-1/3 bg-primary animate-[sk-cubeGridScaleDelay_1.3s_infinite_ease-in-out] [animation-delay:0.1s]" />
        <div className="float-left h-1/3 w-1/3 bg-primary animate-[sk-cubeGridScaleDelay_1.3s_infinite_ease-in-out] [animation-delay:0.2s]" />
      </div>
    </div>
  );
}
